import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { numberWithCommas } from '../../utils';
import CartBannerComponent from "./CartBannerComponent";
import ProductDetailsMain from "./ProdectDetailsMain";
import "./index.css";

const ProductBanners = () => {
  const { productId } = useParams();
  const [productDetails, setProductDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Reset states when productId changes
    setLoading(true);
    setError(null);
    
    fetch(`${process.env.REACT_APP_API_URL}/products/get/${productId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Product not found');
        }
        return response.json();
      })
      .then((data) => {
        setProductDetails(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [productId]); // Added productId as dependency

  // Loading State
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner-border text-danger" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <h3 className="mt-3 text-muted">Loading product details...</h3>
      </div>
    );
  }

  // Error State
  if (error) {
    return (
      <div className="error-container">
        <div className="alert alert-danger" role="alert">
          <i className="fa fa-exclamation-triangle me-2"></i>
          <strong>Error:</strong> {error}
        </div>
        <button 
          className="btn btn-danger"
          onClick={() => window.location.reload()}
        >
          <i className="fa fa-refresh me-2"></i>
          Try Again
        </button>
      </div>
    );
  }

  // Main Content
  return (
    <>
      {productDetails && (
        <>
          <CartBannerComponent title={productDetails.name} />
          <div className="container">
            <ProductDetailsMain
              title={productDetails.name}
              price={"৳" + numberWithCommas(productDetails.price)}
              brand={productDetails.model}
              ProductCode={productDetails.product_code || "Product 19"}
              Availability={productDetails.quantity > 0 ? "In Stock" : "Out of Stock"}
              Quality="0"
              productObj={productDetails}
            />
          </div>
        </>
      )}
    </>
  );
};

export default ProductBanners;